/* Unpinned theme interactions: header and flight bar, hero route, departure board, trip finder,
   destination tabs and maps, scrolling route story, sample trip dialog, trip planner, departure list. No dependencies. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var SVGNS = 'http://www.w3.org/2000/svg';
  var PLANE = 'M13 0c0-1.6-1.6-2.4-3.4-2.4H3L-4.4-12H-8l4.4 9.6h-6l-2.8-3.6H-15l1.8 6-1.8 6h2.6l2.8-3.6h6L-8 12h3.6L3 2.4h6.6C11.4 2.4 13 1.6 13 0Z';
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var uid = 0;

  function noMotion() { return reduceMq.matches || root.getAttribute('data-up-motion') === 'off'; }
  function $(sel, scope) { return (scope || doc).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || doc).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lc(s) { return String(s || '').trim().toLowerCase(); }
  function splitList(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function svgEl(tag, attrs, parent) {
    var el = doc.createElementNS(SVGNS, tag);
    Object.keys(attrs || {}).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    if (parent) parent.appendChild(el);
    return el;
  }
  function onScrollFrame(fn) {
    var ticking = false;
    function run() { ticking = false; fn(); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
  }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
  function replay(node, cls) {
    cls = cls || 'is-entering';
    if (noMotion() || !node) return;
    node.classList.remove(cls);
    void node.offsetWidth;
    node.classList.add(cls);
    clearTimeout(node._upReplay);
    node._upReplay = setTimeout(function () { node.classList.remove(cls); }, 1400);
  }
  function whenSettled(fn) {
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fn);
    window.addEventListener('load', fn);
  }

  /* A dotted route that can be revealed from 0 to 1 using a mask. */
  function makeDotted(svg, d, withPlane, planeScale) {
    var id = 'UpMask' + (++uid);
    var defs = svgEl('defs', {}, svg);
    var mask = svgEl('mask', { id: id, maskUnits: 'userSpaceOnUse', x: -2000, y: -2000, width: 8000, height: 200000 }, defs);
    var reveal = svgEl('path', { d: d, 'class': 'up-dots-mask' }, mask);
    svgEl('path', { d: d, 'class': 'up-dots up-dots--shadow', mask: 'url(#' + id + ')' }, svg);
    var path = svgEl('path', { d: d, 'class': 'up-dots', mask: 'url(#' + id + ')' }, svg);
    var len = path.getTotalLength();
    var plane = withPlane ? svgEl('path', { d: PLANE, 'class': 'up-route-plane' }, svg) : null;
    reveal.style.strokeDasharray = len + ' ' + (len + 40);
    function set(p) {
      p = clamp(p, 0, 1);
      reveal.style.strokeDashoffset = String(len * (1 - p));
      if (plane) {
        var at = Math.max(.5, len * p);
        var a = path.getPointAtLength(Math.max(0, at - 1));
        var b = path.getPointAtLength(Math.min(len, at + 1));
        var angle = Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
        var pt = path.getPointAtLength(at);
        plane.setAttribute('transform', 'translate(' + pt.x.toFixed(1) + ' ' + pt.y.toFixed(1) + ') rotate(' + angle.toFixed(1) + ') scale(' + (planeScale || .82) + ')');
        plane.style.opacity = p > 0.002 ? '1' : '0';
      }
    }
    return { set: set, length: len, path: path, plane: plane };
  }

  var inits = {};

  /* ---------- Header ---------- */
  inits.header = function (el) {
    var toggle = $('[data-up-menu]', el);
    var nav = toggle ? doc.getElementById(toggle.getAttribute('aria-controls')) : null;
    var label = $('[data-up-menu-label]', el);
    function scrolled() { el.classList.toggle('is-scrolled', window.scrollY > 8); }
    onScrollFrame(scrolled);
    scrolled();
    var flight = $('[data-up-flight]', el);
    if (flight) {
      var progress = function () {
        var max = root.scrollHeight - window.innerHeight;
        flight.style.setProperty('--p', (max > 0 ? clamp(window.scrollY / max, 0, 1) : 0).toFixed(4));
      };
      onScrollFrame(progress);
      progress();
      window.addEventListener('resize', debounce(progress, 150));
    }
    if (!toggle || !nav) return;
    function setOpen(open) {
      el.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('up-lock', open);
      if (label) label.textContent = open ? label.getAttribute('data-open') : label.getAttribute('data-closed');
      var main = doc.getElementById('up-main');
      if (main) main.inert = open;
    }
    toggle.addEventListener('click', function () { setOpen(toggle.getAttribute('aria-expanded') !== 'true'); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) { setOpen(false); toggle.focus(); }
    });
    var desk = window.matchMedia('(min-width: 990px)');
    var onDesk = function (m) { if (m.matches) setOpen(false); };
    if (desk.addEventListener) desk.addEventListener('change', onDesk);
  };

  /* ---------- Hero ---------- */
  inits.hero = function (el) {
    var visual = $('[data-up-hero-visual]', el);
    var svg = $('[data-up-hero-route]', el);
    var layers = $$('[data-up-depth]', el);

    if (layers.length && !noMotion()) {
      var parallax = function () {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var y = Math.max(0, -r.top);
        layers.forEach(function (l) { l.style.setProperty('--py', (y * parseFloat(l.getAttribute('data-up-depth') || 0)).toFixed(1) + 'px'); });
      };
      onScrollFrame(parallax);
      parallax();
    }

    if (!svg || !visual) return;
    var from = $('[data-up-route-from]', el);
    var end = $('[data-up-route-end]', el);
    var route = null;
    var progress = 0;
    var started = false;

    function build() {
      var W = visual.offsetWidth, H = visual.offsetHeight;
      if (!W || !H) return;
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var a = from ? { x: from.offsetLeft + from.offsetWidth * .86, y: from.offsetTop + from.offsetHeight * .1 } : { x: W * .3, y: H * .72 };
      var c = end ? { x: end.offsetLeft + end.offsetWidth * .12, y: end.offsetTop + end.offsetHeight * .86 } : { x: W * .86, y: H * .12 };
      var m = { x: W * .52, y: H * .5 };
      var d = 'M' + a.x.toFixed(1) + ',' + a.y.toFixed(1) +
        ' C' + (a.x + W * .02).toFixed(1) + ',' + (a.y - H * .2).toFixed(1) + ' ' + (m.x - W * .24).toFixed(1) + ',' + (m.y + H * .14).toFixed(1) + ' ' + m.x.toFixed(1) + ',' + m.y.toFixed(1) +
        ' S' + (c.x - W * .26).toFixed(1) + ',' + (c.y + H * .3).toFixed(1) + ' ' + c.x.toFixed(1) + ',' + c.y.toFixed(1);
      route = makeDotted(svg, d, false);
      route.set(progress);
    }
    function animate() {
      if (started) return;
      started = true;
      if (noMotion()) { progress = 1; if (route) route.set(1); return; }
      var t0 = null, dur = 2200;
      function step(t) {
        if (t0 === null) t0 = t;
        var k = clamp((t - t0) / dur, 0, 1);
        progress = 1 - Math.pow(1 - k, 3);
        if (route) route.set(progress);
        if (k < 1) requestAnimationFrame(step);
      }
      setTimeout(function () { requestAnimationFrame(step); }, 450);
    }
    build();
    animate();
    whenSettled(build);
    window.addEventListener('resize', debounce(build, 150));
  };

  /* ---------- Trip finder ---------- */
  inits.finder = function (el) {
    var chips = $$('[data-up-mood]', el);
    var panels = $$('[data-up-mood-panel]', el);
    function select(id) {
      chips.forEach(function (c) {
        var on = c.getAttribute('data-up-mood') === id;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.classList.toggle('is-active', on);
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-up-mood-panel') === id;
        if (on && p.hidden) { p.hidden = false; replay(p); }
        else if (!on) p.hidden = true;
      });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        select(c.getAttribute('data-up-mood'));
        var row = c.parentNode;
        if (row && row.scrollWidth > row.clientWidth) {
          row.scrollTo({ left: c.offsetLeft - 16, behavior: noMotion() ? 'auto' : 'smooth' });
        }
      });
    });
    el.upSelectBlock = select;
  };

  /* ---------- Destinations ---------- */
  inits.destinations = function (el) {
    var tabs = $$('[role="tab"]', el);
    var panels = $$('[role="tabpanel"]', el);
    var seen = false;
    function activeMap() {
      var p = panels.filter(function (x) { return !x.hidden; })[0];
      return p ? $('[data-up-map]', p) : null;
    }
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        var on = p.id === tab.getAttribute('aria-controls');
        if (on && p.hidden) {
          p.hidden = false;
          replay(p);
          var fig = $('[data-up-map]', p);
          if (fig) drawMap(fig, seen);
        } else if (!on) p.hidden = true;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') j = 0;
        if (e.key === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); select(tabs[j], true); }
      });
    });
    var first = activeMap();
    if (first) {
      drawMap(first, false);
      if ('IntersectionObserver' in window && !noMotion()) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting || seen) return;
            seen = true;
            obs.disconnect();
            var m = activeMap();
            if (m) drawMap(m, true);
          });
        }, { threshold: .35 });
        $$('[data-up-map]', el).forEach(function (m) { obs.observe(m); });
      } else seen = true;
    }
    whenSettled(function () { var m = activeMap(); if (m) { m._upU = 0; drawMap(m, false); } });
    window.addEventListener('resize', debounce(function () { var m = activeMap(); if (m) drawMap(m, false); }, 150));
    el.upSelectKey = function (key) {
      var t = tabs.filter(function (x) { return x.getAttribute('data-up-tab-key') === key; })[0];
      if (t) { seen = true; select(t); }
    };
    el.upSelectBlock = function (blockId) {
      var t = doc.getElementById('UpTab-' + blockId);
      if (t) select(t);
    };
  };

  /* Country maps: places plotted from latitude and longitude on a pre-projected outline,
     joined by a dotted route that draws itself with the plane. */
  function smoothPath(p) {
    var d = 'M' + p[0].x.toFixed(1) + ',' + p[0].y.toFixed(1);
    for (var i = 0; i < p.length - 1; i++) {
      var p0 = p[i - 1] || p[i], p1 = p[i], p2 = p[i + 1], p3 = p[i + 2] || p2;
      d += ' C' + (p1.x + (p2.x - p0.x) / 6).toFixed(1) + ',' + (p1.y + (p2.y - p0.y) / 6).toFixed(1) + ' ' +
        (p2.x - (p3.x - p1.x) / 6).toFixed(1) + ',' + (p2.y - (p3.y - p1.y) / 6).toFixed(1) + ' ' + p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
    }
    return d;
  }
  function drawMap(fig, play) {
    var svg = $('svg', fig);
    var plot = svg ? $('[data-up-map-plot]', svg) : null;
    if (!plot) return;
    var w = svg.getBoundingClientRect().width;
    if (!w) return;
    var vb = svg.viewBox.baseVal, W = vb.width, H = vb.height;
    var u = W / w;
    if (!play && fig._upU && Math.abs(fig._upU - u) < .02) return;
    fig._upU = u;
    svg.style.setProperty('--u', u.toFixed(3));
    clearTimeout(fig._upT);
    fig.classList.remove('is-stamped');
    while (plot.firstChild) plot.removeChild(plot.firstChild);
    var lng0 = +svg.getAttribute('data-lng0'), lat1 = +svg.getAttribute('data-lat1');
    var kx = +svg.getAttribute('data-kx'), ky = +svg.getAttribute('data-ky');
    var items = $$('[data-lat]', fig);
    var pts = items.map(function (li) {
      var lat = parseFloat(li.getAttribute('data-lat')), lng = parseFloat(li.getAttribute('data-lng'));
      var nm = $('.up-map__name', li);
      return { li: li, name: nm ? nm.textContent.trim() : '', x: (lng - lng0) * kx, y: (lat1 - lat) * ky, side: li.getAttribute('data-side') || '' };
    }).filter(function (p) { return isFinite(p.x) && isFinite(p.y); });
    if (!pts.length) return;
    var route = fig.getAttribute('data-route') === 'true' && pts.length > 1;
    var line = null;
    if (route) {
      line = makeDotted(plot, smoothPath(pts), true, .62 * u);
      $$('.up-dots', plot).forEach(function (pth) {
        pth.style.strokeWidth = String((pth.classList.contains('up-dots--shadow') ? 5 : 3) * u);
        pth.style.strokeDasharray = '0 ' + (7.5 * u).toFixed(2);
      });
      var mk = $('.up-dots-mask', plot);
      if (mk) mk.style.strokeWidth = String(16 * u);
    }
    // where each stop sits along the route, 0 to 1
    var cum = [0];
    for (var i = 1; i < pts.length; i++) cum.push(cum[i - 1] + Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y));
    var total = cum[cum.length - 1] || 1;
    var fs = 10.5 * u;
    pts.forEach(function (p, i) {
      var g = svgEl('g', { 'class': 'up-map__pin' + (route ? '' : ' up-map__pin--dot'), transform: 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')' }, plot);
      if (route) {
        svgEl('circle', { r: (8.5 * u).toFixed(2), 'class': 'up-map__pin-bg' }, g);
        var num = svgEl('text', { y: (3.2 * u).toFixed(2), 'text-anchor': 'middle', 'class': 'up-map__pin-num' }, g);
        num.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      } else {
        svgEl('circle', { r: (9 * u).toFixed(2), 'class': 'up-map__pin-halo' }, g);
        svgEl('circle', { r: (4.2 * u).toFixed(2), 'class': 'up-map__pin-dot' }, g);
      }
      var side = p.side;
      var tw = p.name.length * fs * .64;
      if (!/^(left|right|above|below)$/.test(side)) side = p.x < W * .6 ? 'right' : 'left';
      if (side === 'right' && p.x + 12 * u + tw > W) side = 'left';
      if (side === 'left' && p.x - 12 * u - tw < 0) side = 'right';
      var at = { right: [12 * u, 3.6 * u, 'start'], left: [-12 * u, 3.6 * u, 'end'], above: [0, -13 * u, 'middle'], below: [0, 20 * u, 'middle'] }[side];
      var lx = at[0];
      if (at[2] === 'middle') lx = clamp(p.x, tw / 2 + 2, W - tw / 2 - 2) - p.x;
      var t = svgEl('text', { x: lx.toFixed(1), y: at[1].toFixed(1), 'text-anchor': at[2], 'class': 'up-map__lbl' }, g);
      t.textContent = p.name;
      p.g = g;
      p.at = route ? cum[i] / total : i / Math.max(1, pts.length - 1);
      if (!p.li._upHover) {
        p.li._upHover = true;
        p.li.addEventListener('mouseenter', function () { if (p.li._upPin) p.li._upPin.classList.add('is-hot'); });
        p.li.addEventListener('mouseleave', function () { if (p.li._upPin) p.li._upPin.classList.remove('is-hot'); });
      }
      p.li._upPin = g;
      g.addEventListener('mouseenter', function () { g.classList.add('is-hot'); p.li.classList.add('is-hot'); });
      g.addEventListener('mouseleave', function () { g.classList.remove('is-hot'); p.li.classList.remove('is-hot'); });
    });

    function show(prog) {
      pts.forEach(function (p) { p.g.classList.toggle('is-on', prog >= p.at - .001); });
      if (line) line.set(prog);
    }
    if (!play || noMotion()) {
      show(1);
      fig.classList.add('is-stamped');
      if (line && line.plane) line.plane.style.opacity = '0';
      return;
    }
    show(0);
    var t0 = null, dur = route ? 1900 : 900;
    function step(t) {
      if (t0 === null) t0 = t;
      var k = clamp((t - t0) / dur, 0, 1);
      show(route ? (k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2) : k);
      if (k < 1) requestAnimationFrame(step);
      else {
        if (line && line.plane) line.plane.style.opacity = '0';
        fig._upT = setTimeout(function () { fig.classList.add('is-stamped'); }, 120);
      }
    }
    requestAnimationFrame(step);
  }

  /* ---------- Hosted trips: dialog and route story ---------- */
  function openDialog(d, opener) {
    if (!d) return;
    if (!d._upWired) {
      d._upWired = true;
      d.addEventListener('click', function (e) {
        if (e.target === d) { closeDialog(d); return; }
        var c = e.target.closest('[data-up-close]');
        if (c) {
          if (c.tagName === 'A') d._upSkipFocus = true;
          closeDialog(d);
        }
      });
      d.addEventListener('close', function () {
        root.classList.remove('up-lock');
        if (d._upOpener && !d._upSkipFocus) d._upOpener.focus();
        d._upSkipFocus = false;
      });
    }
    d._upOpener = opener || null;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
    else d.setAttribute('open', '');
    root.classList.add('up-lock');
    var panel = $('.up-dialog__panel', d);
    if (panel) panel.scrollTop = 0;
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') { if (d.open) d.close(); }
    else { d.removeAttribute('open'); root.classList.remove('up-lock'); }
  }

  inits.trip = function (el) {
    $$('[data-up-open]', el).forEach(function (btn) {
      btn.addEventListener('click', function () { openDialog(doc.getElementById(btn.getAttribute('data-up-open')), btn); });
    });
    var route = $('[data-up-route]', el);
    if (route) initRoute(route);
  };

  function initRoute(route) {
    var list = $('.up-route__list', route);
    var svg = $('[data-up-route-line]', route);
    var stops = $$('[data-up-stop]', route);
    var frames = $$('[data-up-frame]', route);
    var legEl = $('[data-up-leg]', route);
    var placeEl = $('[data-up-place]', route);
    var meter = $('[data-up-meter]', route);
    var line = null, active = -1;
    if (!list || !stops.length) return;
    route.classList.add('is-live');

    function build() {
      if (!svg) return;
      var h = list.offsetHeight;
      if (!h) return;
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      svg.setAttribute('viewBox', '0 0 52 ' + h);
      var x0 = 16;
      var ys = stops.map(function (s) { return s.offsetTop + 12; });
      var d = 'M' + x0 + ',' + ys[0];
      for (var i = 1; i < ys.length; i++) {
        var y0 = ys[i - 1], y1 = ys[i], dy = y1 - y0, amp = (i % 2 ? 1 : -1) * 20;
        d += ' C' + (x0 + amp) + ',' + (y0 + dy * .35).toFixed(1) + ' ' + (x0 + amp) + ',' + (y0 + dy * .65).toFixed(1) + ' ' + x0 + ',' + y1;
      }
      line = makeDotted(svg, d, true);
      update();
    }
    function update() {
      var r = list.getBoundingClientRect();
      var mark = window.innerHeight * .55;
      var first = stops[0].offsetTop + 12, last = stops[stops.length - 1].offsetTop + 12;
      var p = clamp((mark - r.top - first) / Math.max(1, last - first), 0, 1);
      if (noMotion()) p = clamp(p, 0, 1);
      if (line) line.set(p);
      if (meter) meter.parentNode.style.setProperty('--p', p.toFixed(3));
      var idx = 0;
      stops.forEach(function (s, i) { if (r.top + s.offsetTop <= mark) idx = i; });
      if (idx !== active) {
        active = idx;
        stops.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        var f = null;
        frames.forEach(function (fr) { if (+fr.getAttribute('data-up-frame') <= idx) f = fr; });
        if (!f) f = frames[0];
        frames.forEach(function (fr) { fr.classList.toggle('is-active', fr === f); });
        if (legEl) legEl.textContent = stops[idx].getAttribute('data-leg') || '';
        if (placeEl) placeEl.textContent = stops[idx].getAttribute('data-place') || '';
      }
    }
    build();
    onScrollFrame(update);
    whenSettled(build);
    window.addEventListener('resize', debounce(build, 150));
    if ('ResizeObserver' in window) {
      var lastH = list.offsetHeight;
      new ResizeObserver(function () { if (Math.abs(list.offsetHeight - lastH) > 2) { lastH = list.offsetHeight; build(); } }).observe(list);
    }
  }

  /* ---------- Departure board: split-flap letters, live clocks, flipping statuses ---------- */
  var FLAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  function makeFlap(node) {
    var a = node.textContent.replace(/\s+/g, ' ').trim();
    var b = (node.getAttribute('data-alt') || '').trim();
    var size = Math.max(a.length, b.length);
    node.textContent = '';
    var sr = doc.createElement('span');
    sr.className = 'up-visually-hidden';
    sr.textContent = b ? a + ' / ' + b : a;
    var vis = doc.createElement('span');
    vis.className = 'up-flap__tiles';
    vis.setAttribute('aria-hidden', 'true');
    var tiles = [];
    for (var i = 0; i < size; i++) {
      var t = doc.createElement('span');
      t.className = 'up-flap__ch';
      vis.appendChild(t);
      tiles.push(t);
    }
    node.appendChild(sr);
    node.appendChild(vis);
    var f = { node: node, tiles: tiles, texts: b ? [a, b] : [a], idx: 0, timers: [] };
    paint(f, a, true);
    return f;
  }
  function setTile(t, ch) {
    t.textContent = ch === ' ' ? ' ' : ch;
    t.classList.toggle('is-blank', ch === ' ');
  }
  function paint(f, text, instant, delay) {
    f.timers.forEach(clearTimeout);
    f.timers = [];
    var target = text.toUpperCase();
    f.tiles.forEach(function (t, i) {
      var ch = target.charAt(i) || ' ';
      if (instant || noMotion()) { setTile(t, ch); return; }
      var spins = ch === ' ' ? 1 : 3 + (i % 3) + Math.floor(Math.random() * 3);
      var start = (delay || 0) + i * 28;
      for (var k = 0; k <= spins; k++) {
        (function (k) {
          f.timers.push(setTimeout(function () {
            setTile(t, k === spins ? ch : FLAP.charAt(Math.floor(Math.random() * FLAP.length)));
            t.classList.remove('is-flip');
            void t.offsetWidth;
            t.classList.add('is-flip');
          }, start + k * 62));
        })(k);
      }
    });
  }
  inits.board = function (el) {
    var flaps = $$('[data-up-flap]', el).map(makeFlap);
    var rows = $$('.up-board__row', el);
    var inView = false, played = false;

    function playAll() {
      flaps.forEach(function (f) {
        var row = f.node.closest('tr');
        var r = Math.max(0, rows.indexOf(row));
        paint(f, f.texts[f.idx], false, r * 140);
      });
    }
    if (!noMotion()) {
      flaps.forEach(function (f) { f.tiles.forEach(function (t) { setTile(t, ' '); }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            inView = en.isIntersecting;
            if (inView && !played) { played = true; playAll(); }
          });
        }, { threshold: .25 }).observe(el);
      } else { played = true; inView = true; playAll(); }
    }

    // Statuses with a second value flip between the two.
    var every = clamp(parseInt(el.getAttribute('data-cycle'), 10) || 6, 3, 30) * 1000;
    if (!noMotion()) {
      setInterval(function () {
        if (!inView || doc.hidden) return;
        flaps.filter(function (f) { return f.texts.length > 1; }).forEach(function (f, i) {
          f.idx = (f.idx + 1) % f.texts.length;
          paint(f, f.texts[f.idx], false, i * 160);
        });
      }, every);
    }

    // Hovering a row reshuffles its destination.
    rows.forEach(function (row) {
      var to = flaps.filter(function (f) { return row.contains(f.node) && f.node.closest('.up-board__c--to'); })[0];
      var last = 0;
      row.addEventListener('mouseenter', function () {
        if (!to || noMotion() || Date.now() - last < 1200) return;
        last = Date.now();
        paint(to, to.texts[to.idx], false, 0);
      });
    });

    // Live local clocks.
    var clocks = $$('[data-up-clock]', el);
    function tick() {
      var now = new Date();
      clocks.forEach(function (c) {
        try {
          var parts = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: c.getAttribute('data-up-clock') }).formatToParts(now);
          var h = '', m = '';
          parts.forEach(function (p) { if (p.type === 'hour') h = p.value; if (p.type === 'minute') m = p.value; });
          c.innerHTML = '';
          c.appendChild(doc.createTextNode(h));
          var colon = doc.createElement('span'); colon.className = 'up-board__colon'; colon.textContent = ':';
          c.appendChild(colon);
          c.appendChild(doc.createTextNode(m));
          c.setAttribute('datetime', h + ':' + m);
        } catch (err) { c.textContent = '--:--'; }
      });
    }
    if (clocks.length) { tick(); setInterval(tick, 15000); }
    el.upSelectBlock = function () { if (!played) { played = true; playAll(); } };
  };

  /* ---------- Departure list: a boarding pass that fills in as you type ---------- */
  inits.club = function (el) {
    var ds = el.dataset;
    var nameIn = $('[data-up-club-name]', el);
    var tags = $('[data-up-club-tags]', el);
    var dests = $$('[data-up-club-dest]', el);
    var pass = $('[data-up-pass]', el);
    var out = {
      name: $('[data-up-pass-name]', el), to: $('[data-up-pass-to]', el), city: $('[data-up-pass-city]', el),
      stub: $('[data-up-pass-stub]', el), seat: $('[data-up-pass-seat]', el)
    };
    var defaults = { city: out.city ? out.city.textContent : '', seat: out.seat ? out.seat.textContent : '' };
    var KEY = 'unpinned-pass';

    function seatFor(name) {
      var h = 0;
      for (var i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
      return (2 + h % 28) + (h % 2 ? 'A' : 'F');
    }
    function paintPass(name, picked) {
      if (out.name) out.name.textContent = name || ds.noName || '';
      var codes = picked.map(function (d) { return d.code || d.name; });
      if (out.to) out.to.textContent = codes.length ? codes.join(' · ') : (ds.noDest || '');
      if (out.city) out.city.textContent = picked.length ? picked.map(function (d) { return d.name; }).join(' + ') : defaults.city;
      if (out.stub) out.stub.textContent = codes.length ? codes.join(' ') : (ds.noDest || '');
      if (out.seat) out.seat.textContent = name ? seatFor(name.toLowerCase()) : defaults.seat;
      if (pass) pass.classList.toggle('is-long', codes.length > 2);
    }
    function picked() {
      return dests.filter(function (d) { return d.checked; }).map(function (d) { return { name: d.value, code: d.getAttribute('data-code') || '' }; });
    }
    function update(animate) {
      var p = picked();
      var name = nameIn ? nameIn.value.trim() : '';
      paintPass(name, p);
      if (tags) tags.value = [ds.baseTag || 'departure-list'].concat(p.map(function (d) { return lc(d.name); })).filter(Boolean).join(', ');
      if (animate) replay(pass, 'is-updated');
    }
    if (nameIn) nameIn.addEventListener('input', function () { update(false); });
    dests.forEach(function (d) { d.addEventListener('change', function () { update(true); }); });
    var form = $('form', el);
    if (form) form.addEventListener('submit', function () {
      try { sessionStorage.setItem(KEY, JSON.stringify({ name: nameIn ? nameIn.value.trim() : '', picked: picked() })); } catch (err) { /* storage unavailable */ }
    });
    var done = $('[data-up-club-done]', el);
    if (done) {
      try {
        var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (saved) paintPass(saved.name || '', saved.picked || []);
      } catch (err) { /* storage unavailable */ }
    } else update(false);

    // The pass tilts a little towards the pointer.
    var wrap = $('.up-club__passwrap', el);
    if (wrap && pass && !noMotion() && window.matchMedia('(hover: hover)').matches) {
      wrap.addEventListener('pointermove', function (e) {
        var r = wrap.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        pass.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
        pass.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg');
      });
      wrap.addEventListener('pointerleave', function () { pass.style.setProperty('--rx', '0deg'); pass.style.setProperty('--ry', '0deg'); });
    }
  };

  /* ---------- Trip planner ---------- */
  inits.planner = function (el) {
    var form = $('[data-up-form]', el);
    if (!form) return;
    var ds = el.dataset;
    var ahead = splitList(ds.ahead).map(lc);
    var unsure = lc(ds.unsure);
    var labels = splitList(ds.fields);
    var ideas = String(ds.ideas || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|').map(function (s) { return s.trim(); });
      if (!parts[0] || !parts[1]) return null;
      return { dest: parts[0], place: parts[1], tags: splitList(parts[2]).map(lc) };
    }).filter(Boolean);
    var codes = {};
    String(ds.codes || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|').map(function (x) { return x.trim(); });
      if (parts[0] && parts[1]) codes[lc(parts[0])] = parts[1];
    });
    var out = {
      to: $('[data-up-brief-to]', el),
      card: $('[data-up-brief]', el),
      fields: $('[data-up-brief-fields]', el),
      route: $('[data-up-brief-route]', el),
      ahead: $('[data-up-brief-ahead]', el),
      unsure: $('[data-up-brief-unsure]', el),
      notes: $('[data-up-brief-notes]', el),
      notesText: $('[data-up-brief-notes-text]', el),
      status: $('[data-up-copy-status]', el),
      lengthOut: $('[data-up-length-out]', el)
    };
    var last = null;

    function nights(n) { return n + ' ' + (n === 1 ? (ds.night || 'night') : (ds.nights || 'nights')); }
    function read() {
      var fd = new FormData(form);
      return {
        who: fd.get('who') || '',
        size: clamp(parseInt(fd.get('size'), 10) || 1, 1, 40),
        where: fd.getAll('where'),
        when: fd.get('when') || '',
        length: parseInt(fd.get('length'), 10) || 0,
        pace: fd.get('pace') || '',
        interests: fd.getAll('interests'),
        comfort: fd.get('comfort') || '',
        notes: String(fd.get('notes') || '').trim()
      };
    }
    function plan(v) {
      var interests = v.interests.map(lc);
      var slow = /slow/i.test(v.pace);
      var packed = /pack|full|busy/i.test(v.pace);
      var names = [];
      ideas.forEach(function (i) { if (names.indexOf(i.dest) < 0) names.push(i.dest); });
      var dests = v.where.filter(function (w) { return lc(w) !== unsure; });
      var guessed = false;
      if (!dests.length) {
        guessed = true;
        var scored = names.map(function (n, idx) {
          var s = ideas.filter(function (i) { return i.dest === n; }).reduce(function (a, i) {
            return a + i.tags.filter(function (t) { return interests.indexOf(t) > -1; }).length;
          }, 0);
          if (ahead.indexOf(lc(n)) > -1) s -= .5;
          return { n: n, s: s - idx * .01 };
        }).sort(function (a, b) { return b.s - a.s; });
        dests = scored.slice(0, v.length >= 12 ? 2 : 1).map(function (x) { return x.n; });
      }
      var per = slow ? 4 : (packed ? 2.5 : 3);
      var stops = [];
      dests.forEach(function (dn, di) {
        var n = Math.floor(v.length / dests.length) + (di < v.length % dests.length ? 1 : 0);
        var pool = ideas.filter(function (i) { return lc(i.dest) === lc(dn); });
        if (!pool.length) { stops.push({ place: dn, dest: '', nights: n }); return; }
        var count = clamp(Math.round(n / per), 1, pool.length);
        var ranked = pool.map(function (i, idx) {
          var hits = i.tags.filter(function (t) { return interests.indexOf(t) > -1; }).length;
          return { i: i, idx: idx, s: hits * 2 + (slow && i.tags.indexOf('slow') > -1 ? 1 : 0) - idx * .01 };
        }).sort(function (a, b) { return b.s - a.s; }).slice(0, count).sort(function (a, b) { return a.idx - b.idx; });
        var base = Math.floor(n / ranked.length), extra = n % ranked.length;
        ranked.forEach(function (r, j) { stops.push({ place: r.i.place, dest: r.i.dest, nights: base + (j < extra ? 1 : 0) }); });
      });
      return { dests: dests, stops: stops, guessed: guessed };
    }
    function values(v, p) {
      var who = v.who;
      var travellers = /solo/i.test(who) ? who : (who ? who + ' × ' + v.size : String(v.size));
      return [travellers, p.dests.join(' + ') || '—', v.when || '—', nights(v.length), v.pace || '—', v.interests.join(', ') || '—', v.comfort || '—'];
    }
    function render(animate) {
      var v = read();
      var p = plan(v);
      var vals = values(v, p);
      last = { v: v, p: p, vals: vals };
      if (out.lengthOut) out.lengthOut.textContent = nights(v.length);
      if (out.to) out.to.textContent = p.dests.map(function (d) { return codes[lc(d)] || d; }).join(' · ') || '—';
      if (out.fields) {
        out.fields.innerHTML = '';
        vals.forEach(function (val, i) {
          var wrap = doc.createElement('div');
          if (i === 1 || i === 5 || i === 6) wrap.className = 'is-wide';
          var dt = doc.createElement('dt'); dt.textContent = labels[i] || '';
          var dd = doc.createElement('dd'); dd.textContent = val;
          wrap.appendChild(dt); wrap.appendChild(dd);
          out.fields.appendChild(wrap);
        });
      }
      if (out.route) {
        out.route.innerHTML = '';
        p.stops.forEach(function (s) {
          if (!s.nights) return;
          var li = doc.createElement('li');
          var name = doc.createElement('span');
          var place = doc.createElement('span'); place.className = 'up-brief__place'; place.textContent = s.place;
          name.appendChild(place);
          if (s.dest && p.dests.length > 1) { var c = doc.createElement('span'); c.className = 'up-brief__country'; c.textContent = s.dest; name.appendChild(c); }
          var n = doc.createElement('span'); n.className = 'up-brief__nights'; n.textContent = nights(s.nights);
          li.appendChild(name); li.appendChild(n);
          out.route.appendChild(li);
        });
      }
      var hasAhead = p.dests.some(function (d) { return ahead.indexOf(lc(d)) > -1; });
      if (out.ahead) out.ahead.hidden = !hasAhead;
      if (out.unsure) out.unsure.hidden = !p.guessed;
      if (out.notes) { out.notes.hidden = !v.notes; if (out.notesText) out.notesText.textContent = v.notes; }
      if (out.status) out.status.textContent = '';
      if (animate) replay(out.card, 'is-updated');
    }
    function briefText() {
      if (!last) render(false);
      var title = $('.up-brief__title', el);
      var lines = [(title ? title.textContent.trim() : 'Trip note').toUpperCase(), ''];
      last.vals.forEach(function (val, i) { lines.push((labels[i] || '') + ': ' + val); });
      var routeLabel = $('.up-brief__route .up-brief__label', el);
      lines.push('', routeLabel ? routeLabel.textContent.trim() + ':' : 'Route:');
      last.p.stops.forEach(function (s, i) { if (s.nights) lines.push((i + 1) + '. ' + s.place + (s.dest && last.p.dests.length > 1 ? ' (' + s.dest + ')' : '') + ', ' + nights(s.nights)); });
      [out.unsure, out.ahead].forEach(function (n) { if (n && !n.hidden) lines.push('', n.textContent.trim()); });
      if (last.v.notes) lines.push('', 'Notes: ' + last.v.notes);
      var foot = $('.up-brief__foot', el);
      if (foot) lines.push('', foot.textContent.trim());
      return lines.join('\n');
    }

    form.addEventListener('input', function () { render(false); });
    form.addEventListener('change', function () { render(false); });
    form.addEventListener('submit', function (e) {
      if (form._upMail) return; // Contact forms must reach Shopify's protected submission handler.
      e.preventDefault();
      render(true);
      if (window.innerWidth < 990 && out.card) out.card.scrollIntoView({ behavior: noMotion() ? 'auto' : 'smooth', block: 'start' });
    });
    $$('[data-up-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input[name="size"]', form);
        var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 40;
        input.value = clamp((parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-up-step'), 10), min, max);
        render(false);
      });
    });
    var reset = $('[data-up-reset]', el);
    if (reset) reset.addEventListener('click', function () { form.reset(); render(true); });
    var copy = $('[data-up-copy]', el);
    if (copy) copy.addEventListener('click', function () {
      var text = briefText();
      var ok = function () { if (out.status) out.status.textContent = ds.copied || 'Copied'; };
      var fail = function () {
        if (out.status) out.status.textContent = ds.copyFail || '';
        try { var range = doc.createRange(); range.selectNodeContents(out.card); var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range); } catch (err) { /* ignore */ }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(ok, fail);
      else fail();
    });
    el.upPrefill = function (list) {
      var names = splitList(list).map(lc);
      if (!names.length) return;
      $$('input[name="where"]', form).forEach(function (i) { i.checked = names.indexOf(lc(i.value)) > -1; });
      render(true);
    };
    render(false);
  };

  /* ---------- Scroll reveal ---------- */
  var io = null;
  function initReveal(scope) {
    if (noMotion() || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('up-reveal-in');
          en.target.classList.remove('up-reveal-pre');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    $$('[data-up-reveal]', scope).forEach(function (n, i) {
      if (n._upRevealed) return;
      n._upRevealed = true;
      if (n.getBoundingClientRect().top > window.innerHeight * .92) {
        n.classList.add('up-reveal-pre');
        n.style.transitionDelay = ((i % 4) * 90) + 'ms';
        io.observe(n);
      }
    });
  }

  /* ---------- Cross-section links ---------- */
  doc.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-up-tab]');
    if (tab && tab.getAttribute('data-up-tab')) {
      $$('[data-up-init="destinations"]').forEach(function (s) { if (s.upSelectKey) s.upSelectKey(tab.getAttribute('data-up-tab')); });
    }
    var pf = e.target.closest('[data-up-prefill]');
    if (pf && pf.getAttribute('data-up-prefill')) {
      $$('[data-up-init="planner"]').forEach(function (s) { if (s.upPrefill) s.upPrefill(pf.getAttribute('data-up-prefill')); });
    }
  });

  /* ---------- Boot + theme editor ---------- */
  function initAll(scope) {
    $$('[data-up-init]', scope).forEach(function (n) {
      if (n._upInit) return;
      var fn = inits[n.getAttribute('data-up-init')];
      if (!fn) return;
      n._upInit = true;
      try { fn(n); } catch (err) { if (window.console) console.error('[Unpinned]', err); }
    });
    initReveal(scope);
  }
  doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest('[data-up-init]');
    if (sec && sec.upSelectBlock && e.detail) sec.upSelectBlock(e.detail.blockId);
  });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initAll(doc); });
  else initAll(doc);
})();
